import Vue from 'vue';
import * as utils from '../utils/request';
import store from './store';
import _ from 'lodash';

/**
 * @typedef {Object} Admin
 * @property {string} id
 * @property {string} name
 * @property {string} email
 * @property {string} picURL
 * @property {boolean} isSuperAdmin
 * @property {number} date
 */

/**
 * @typedef {Object} Organization
 * @property {string} id
 * @property {string} name
 * @property {string} description
 * @property {string} picURL
 * @property {Admin[]} admins
 */

// parameter should be organization id, to get only members of the specified organization

// mock data
// const admins = [...new Array(15)].map((v, i) => ({
//   id: `admin-${i + 1}`,
//   name: `AdminFirst ${i + 1} Last`,
//   email: `admin${i + 1}last@mmi-test.com`,
//   picURL: require('@/assets/avatar-placeholder.png'),
//   isSuperAdmin: false,
//   date: new Date().getTime() - (86400000 * (15 - i))
// }));

store.registerModule('organization', {
  namespaced: true,
  state: {
    // mock data
    /** @type {Organization} */
    organization: {}
  },
  mutations: {
    /**
     * @param state
     * @param {Object} opts
     * @param {Admin[]} opts.items
     * @param {boolean} opts.upsert
     */
    updateInOrganizations (state, opts) {
      const { items, upsert } = opts;
      const list = state.admins;
      items.forEach(item => {
        const index = list.findIndex(b => b.id === item.id);
        if (~index) {
          Vue.set(list, index, item);
          return;
        }

        if (upsert) {
          list.push(item);
        }
      });
    },
    setOrganization (state, value) {
      state.organization = value;
    }
  },
  actions: {
    /**
     * @param ctx
     * @param {Object} opts
     * @param {string} opts.id
     * @param {number} opts.limit
     * @param {boolean} opts.keyword
     * @returns {Organization}
     */
    async getOrganization (ctx, opts) {
      if (!_.isEmpty(ctx.state.organization)) return ctx.state.organization;
      const query = {
        method: 'get'
      };
      const org = await utils.request(`organizations/${opts.id}`, query);
      ctx.commit('setOrganization', org);
      return org;
    },
    /**
     * @param ctx
     * @param {Object} payload
     * @param {string} payload.picURL
     * @param {string} payload.name
     * @param {string} payload.descrition
     */
    async updateOrganization (ctx, payload) {
      const query = {
        method: 'put',
        body: {
          ..._.omit(payload, 'id')
        }
      };
      const org = await utils.request(`organizations/${payload.id}`, query);
      ctx.commit('setOrganization', org);
    },
    async findAdmins (ctx, opts) {
      // TODO: query firebase with query params
      // TODO: query admins
      const result = ctx.state.organization.admins.filter(admin => (admin.name.toUpperCase().search(opts.keyword.toUpperCase()) > -1 || admin.email.toUpperCase().search(opts.keyword.toUpperCase()) > -1));
      return result;
    }
  }
});
